import { msg } from 'gt-react';
import { ClipboardTextIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
  requireModules,
} from '../route';

const SupplierProductMatchesPage = lazyRouteComponent(
  () => import('./SupplierProductMatchesPage'),
  'SupplierProductMatchesPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/supplier-product-matches',
  staticData: {
    app: {
      nav: {
        label: msg('Product Matches', {
          context: 'sidebar nav label, Accounts Payable section',
        }),
        icon: <ClipboardTextIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Payable',
        order: 40,
        groupOrder: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SupplierProductMatch },
        ],
      },
    },
  },
  component: SupplierProductMatchesPage,
  loader: () => ({
    crumb: msg('Supplier Product Matches', { context: 'page breadcrumb' }),
  }),
  validateSearch: z.object({
    supplierId: z.string().optional(),
    productId: z.string().optional(),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Read, subject: Subject.SupplierProductMatch },
      ],
    });
  },
});
